 export const productRefresh = '/api/office/product/listV3/localRefreshForPc'
